import type {
  Block,
  ParagraphData,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";

import "./subheading.css";

export default function SubheadingView({
  block,
}: {
  block: Block;
}) {
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-subheading">
      {(data.textParts || []).map((part, i) => {
        if (part.type === "text") {
          return <span key={i}>{part.value}</span>;
        }

        return (
          <RefLink
            key={i}
            targetId={part.targetId}
            label={part.label}
            className="pdf-ref-link text-primary"
          />
        );
      })}
    </div>
  );
}
